import React from "react";

export default function Content() {
  return (
    <div className="shadow-lg p-3 mb-5 bg-body-tertiary rounded mt-5">
      <div id="home" className="container mt-4">
        <img
          src="./assets/abhii.gif"
          className="img-gif my-3 mx-auto d-block"
          alt="..."
        />
        <div className="container info ">
          <h3 className="text-center mt-4">I am Abhishek Kumar</h3>
          <p className="text-center my-3">
            {/* Logical and organised individual with a strong foundation in
              software engineering. Proficient in C++, C/, PHP and Java. Seeking
              to raise coding KPIs by providing error-free codes. Ability to
              translate business requirements into innovative software solutions.
              Excellent teamwork, interpersonal and communication skills. Looking
              to start a career as an entry-level professional with a reputed IT
              company. */}
            Highly motivated and Dedicated and detail-oriented Software
            Development professional with a strong foundation in Computer
            Science. Graduated with a B.Tech degree in CSE from Sagar Institute
            of Technology and Management. Ability to translate business
            requirements into innovative software solutions. Seeking
            opportunities to contribute to meaningful projects and further
            enhance technical expertise.
          </p>
        </div>

        <div className="container link mt-4">
          {/* <!-- links --> */}
          <div id="linking">
            <a href="mailto:krabhi977@gmail.com">
              <img
                src="./assets/envelope-solid.svg"
                className="falink"
                alt=""
              />
            </a>
            <a href="https://www.linkedin.com/in/krabhi977/">
              <img src="./assets/linkedin.svg" className="falink" alt="" />
            </a>
            <a href="tel:+917524954879">
              <img src="./assets/phone-solid.svg" className="falink" alt="" />
            </a>
            <a href="https://github.com/krabhi977/">
              <img src="./assets/github.svg" className="falink" alt="" />
            </a>
          </div>
        </div>

        <div className="text-center my-4">
          <a href="./assets/abhi-resume.pdf" download="abhishek-resume">
          <button className="btn btn-light border border-2">
            Download
            <svg
              className="ms-2 fs-3"
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              viewBox="0 0 640 512"
            >
              <path d="M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z" />
            </svg>
          </button>
          </a>
        </div>

        <hr className="border border-dark border-2 opacity-75 w-25 mx-auto "></hr>
      </div>
    </div>
  );
}
